module.exports = __webpack_public_path__ + "media/images/star-emoji-b784f438320217d258884ce26b223407.svg";